export default __webpack_public_path__ + "static/media/img28.418ac216.jpg";